export default __webpack_public_path__ + "static/media/ChristineJones-8.8f1ad1c5.jpg";